<div class="header">
    <div class="top">
        <h3>Comedor /</h3>
        <div class="breadcrumb">
            <mat-icon svgIcon="arrow back"></mat-icon>
            <h2> Configuración de envío</h2>
        </div>
    </div>
</div>
<div class="content">
    <div class="configuration">
        <h2>Catering</h2>
        <h3>ESCRIBA EL NÚMERO DE RESERVAS SIN EMPLEADO</h3>
        <mat-form-field appearance="outline">
            <input matInput type="text">
        </mat-form-field>
        <mat-divider></mat-divider>
        <h3>SELECCIONE LA HORA DE ENVÍO</h3>
        <mat-form-field appearance="outline">
            <input matInput type="time">
            <mat-icon matPrefix svgIcon="acute"></mat-icon>
        </mat-form-field>
        <mat-divider></mat-divider>
        <div class="buttons">
            <button mat-flat-button id="action">Guardar cambios</button>
            <button mat-flat-button id="cancel">Cancelar</button>
        </div>
    </div>
    <div class="configuration">
        <h2>Gestoría</h2>
        <h3>ESCRIBA EL CORREO DEL DESTINATARIO</h3>
        <mat-form-field appearance="outline">
            <input matInput type="email">
        </mat-form-field>
        <mat-divider></mat-divider>
        <h3>SELECCIONE LA HORA DE ENVÍO</h3>
        <mat-form-field appearance="outline">
            <input matInput type="time">
            <mat-icon matPrefix svgIcon="acute"></mat-icon>
        </mat-form-field>
        <mat-divider></mat-divider>
        <div class="buttons">
            <button mat-flat-button id="action">Guardar cambios</button>
            <button mat-flat-button id="cancel">Cancelar</button>
        </div>
    </div>
</div>